import { PlumeMeta } from "../../dataModel";



export const PlumeMetas: PlumeMeta[] = [
    {
        id: "Mexico_Durango_BV1_BV1-1",
        plumeSourceId: "BV1",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 1",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-104.530079",
        lat: "26.297686",
        totalReleaseMass: "N/A",
        colEnhancements: "0.44",
        startDatetime: "2019-04-07 16:16",
        endDatetime: "2019-04-07 19:11",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "2:55:00",
    },
    {
        id: "Mexico_Durango_BV1_BV1-2",
        plumeSourceId: "BV1",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 1",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-104.530079",
        lat: "26.297686",
        totalReleaseMass: "N/A",
        colEnhancements: "0.5",
        startDatetime: "2019-05-21 17:31",
        endDatetime: "2019-05-21 19:16",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "1:45:00",
    },
    {
        id: "Mexico_Durango_BV2_BV2-1",
        plumeSourceId: "BV2",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 2",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-104.316830",
        lat: "26.085840",
        totalReleaseMass: "570",
        colEnhancements: "0.4",
        startDatetime: "2019-04-09 17:46",
        endDatetime: "2019-04-09 21:51",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "4:05:00",
    },
    {
        id: "Mexico_Durango_BV2_BV2-2",
        plumeSourceId: "BV2",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 2",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-104.316830",
        lat: "26.085840",
        totalReleaseMass: "620",
        colEnhancements: "0.32",
        startDatetime: "2019-04-10 16:31",
        endDatetime: "2019-04-10 18:21",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "1:50:00",
    },
    {
        id: "Mexico_Durango_BV2_BV2-3",
        plumeSourceId: "BV2",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 2",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-104.316830",
        lat: "26.085840",
        totalReleaseMass: "860",
        colEnhancements: "0.3",
        startDatetime: "2019-04-18 17:11",
        endDatetime: "2019-04-18 20:21",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "3:10:00",
    },
    {
        id: "Mexico_Durango_BV2_BV2-4",
        plumeSourceId: "BV2",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 2",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-104.316830",
        lat: "26.085840",
        totalReleaseMass: "N/A",
        colEnhancements: "0.28",
        startDatetime: "2019-05-11 15:01",
        endDatetime: "2019-05-11 16:11",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "1:10:00",
    },
    {
        id: "Mexico_Durango_BV2_BV2-5",
        plumeSourceId: "BV2",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 2",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-104.316830",
        lat: "26.085840",
        totalReleaseMass: "1130-1380",
        colEnhancements: "0.34",
        startDatetime: "2019-05-12 16:31",
        endDatetime: "2019-05-12 19:31",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "3:00:00",
    },
    {
        id: "Mexico_Durango_BV4_BV4-1",
        plumeSourceId: "BV4",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 4",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-103.855128",
        lat: "25.681875",
        totalReleaseMass: "N/A",
        colEnhancements: "0.58",
        startDatetime: "2019-05-16 16:51",
        endDatetime: "2019-05-16 17:31",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "0:40:00",
    },
    {
        id: "Mexico_Durango_BV4_BV4-2",
        plumeSourceId: "BV4",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 4",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-103.855128",
        lat: "25.681875",
        totalReleaseMass: "440",
        colEnhancements: "0.45",
        startDatetime: "2019-05-22 17:36",
        endDatetime: "2019-05-22 18:56",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "1:20:00",
    },
    {
        id: "Mexico_Durango_BV4_BV4-3",
        plumeSourceId: "BV4",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 4",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-103.855128",
        lat: "25.681875",
        totalReleaseMass: "N/A",
        colEnhancements: "0.56",
        startDatetime: "2019-05-23 14:26",
        endDatetime: "2019-05-23 16:06",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "1:40:00",
    },
    {
        id: "Mexico_Durango_BV4_BV4-4",
        plumeSourceId: "BV4",
        plumeSourceName: "El Encino La Laguna Pipeline Block Valve 4",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-104.530079",
        lat: "26.297686",
        totalReleaseMass: "350",
        colEnhancements: "0.91",
        startDatetime: "2019-05-24 15:21",
        endDatetime: "2019-05-24 17:31",
        country: "Mexico",
        administrativeDivision: "Durango",
        duration: "2:10:00",
    },
    {
        id: "USA_Indiana_Indiana_IN-1",
        plumeSourceId: "Indiana",
        plumeSourceName: "Medaryville, Indiana 1",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-86.8759956",
        lat: "41.061246",
        totalReleaseMass: "550",
        colEnhancements: "0.5",
        startDatetime: "2020-06-15 14:16",
        endDatetime: "2020-06-15 15:16",
        country: "USA",
        administrativeDivision: "Indiana",
        duration: "1:00:00",
    },
    {
        id: "USA_Indiana_Indiana_IN-2",
        plumeSourceId: "Indiana",
        plumeSourceName: "Goodland, Indiana 1",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-87.2853354",
        lat: "40.718675",
        totalReleaseMass: "440",
        colEnhancements: "0.42",
        startDatetime: "2020-06-15 14:16",
        endDatetime: "2020-06-15 15:16",
        country: "USA",
        administrativeDivision: "Indiana",
        duration: "1:00:00",
    },
    {
        id: "USA_Texas_Permian_PB-1",
        plumeSourceId: "Permian",
        plumeSourceName: "Permian Basin 1 ?",
        imageUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        tiffUrl: "https://dev.ghg.center/api/raster/collections/goes-ch4/items/GOES-CH4_Permian_2023-07-26T17:36:00Z/preview.png?assets=rad&amp;rescale=0.0%2C0.2&amp;colormap_name=magma",
        lon: "-103.843",
        lat: "31.552",
        totalReleaseMass: "60",
        colEnhancements: "0.16",
        startDatetime: "2023-07-26 16:36",
        endDatetime: "2023-07-26 16:56",
        country: "USA",
        administrativeDivision: "Texas",
        duration: "0:20:00",
    },
]
